import { u, styled } from '../../../shared/theming-sc'

const ScrollBar = styled.div`
    width: 100%;
    box-sizing: border-box;
    float: left;
    position: relative;

    margin-top: ${u.getSpacing('medium')}px;

    ${u.media.lessThan('md')`
       padding-left: 20px !important;
  `};
`

const ScrollTrack = styled.div`
    width: 100%;
    float: left;
    position: relative;
    height: ${u.getSpacing('smaller')}px;
`

const ScrollHandle = styled.div`
    width: 100px;
    border-radius: 20px;
    height: ${u.getSpacing('smaller')}px;
    position: absolute;
    background: ${u.getColor('greyLightest')};
`

const ScrollButtons = styled.div`
    width: 100%;
    float: left;
    clear: both;
    background: white;
    margin-top: ${u.getSpacing('smaller')}px;
    position: relative;
`

const ScrollButtonLeft = styled.span`
    width: 20px;
    height: 20px;
    float: left;
    cursor: pointer;
    position: absolute;
    left: -25px;
    top: -24px;

    transform: rotate(270deg);
`

const ScrollButtonRight = styled.span`
    width: 20px;
    height: 20px;
    float: left;
    cursor: pointer;
    position: absolute;
    right: -25px;
    top: -24px;

    transform: rotate(90deg);

`

const ScrollMobile = styled.div`
    width: 100%;
    height: 40px;
    float: left;
    margin: ${u.getSpacing('smaller')}px 0 0 0;
    position: relative;
    text-align: center;
`

const ScrollMobileBar = styled.div`
    display: none;
`

const ScrollMobileDots = styled.div`
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    position: absolute;
    left: 0;
    padding: 0;
    top: -22px;
    text-align: center;
`

const ScrollMobileButtonDot = styled.span`
    display: inline-block;
    width: 6px;
    height: 6px;
    background: ${u.getColor('grey')};
    cursor: pointer;
    margin: -${u.getSpacing('tiny')}px ${u.getSpacing('tiny')}px 0;
    border-radius: 10px;
    top: -${u.getSpacing('tiny')}px;
    position: relative;
`

const ScrollMobileButtonDotActive = styled.span`
    display: inline-block;
    width: 6px;
    height: 6px;
    background: ${u.getColor('greyDark')};
    cursor: pointer;
    margin: -${u.getSpacing('tiny')}px ${u.getSpacing('tiny')}px 0;
    border-radius: 10px;
    top: -${u.getSpacing('tiny')}px;
    position: relative;
`

const ScrollMobileButtonLeft = styled.span`
    width: 20px;
    height: 20px;
    float: left;
    cursor: pointer;
    position: absolute;
    left: -25px;
    top: -24px;

    transform: rotate(270deg);
`

const ScrollMobileButtonRight = styled.span`
    width: 20px;
    height: 20px;
    float: right;
    cursor: pointer;
    position: absolute;
    right: -25px;
    top: -24px;

    transform: rotate(90deg);
`

export {
  ScrollBar,
  ScrollHandle,
  ScrollTrack,
  ScrollButtons,
  ScrollButtonLeft,
  ScrollButtonRight,

  ScrollMobile,
  ScrollMobileBar,
  ScrollMobileButtonLeft,
  ScrollMobileButtonRight,
  ScrollMobileDots,
  ScrollMobileButtonDot,
  ScrollMobileButtonDotActive
}
